export default [
    // user login
    {
        url: '/sysUser/login',
        type: 'post',
        response: config => {
            // 模拟错误情况，用户名、密码不正确
            // if (!res_token) {
            //     return {
            //         code: 600,
            //         msg: '登录名 或者 密码不正确，请重新输入'
            //     }
            // }

            // 成功登录
            return {
                code: 0,
                msg: '执行成功',
                data: {
                    total: '10'
                }
            }
        }
    }
]